import Vue from 'vue'
import factory from '../services/api'

Vue.use(factory)
